import {get, has} from 'lodash';

export const TreatmentNodeHeaders = {
  TREATMENT_PLANS_HEADER: '',
  CLINICAL_TRIALS_HEADER: 'CT: '
};

export class TreatmentNodeUtils {
  public static createName(treatmentPlans: any[], clinicalTrial: {}): string {
    let treatmentPlanNodeName = TreatmentNodeHeaders.TREATMENT_PLANS_HEADER + '0 On-pathway treatment plans';

    if (treatmentPlans.length > 0 || clinicalTrial) {
      const primaryTreatmentPlanArr = treatmentPlans.filter(treatmentPlan => treatmentPlan.primary);
      if (primaryTreatmentPlanArr && primaryTreatmentPlanArr.length > 0) {
        const primaryPlan = primaryTreatmentPlanArr[0];
        const nameArr = [primaryPlan.treatmentPlan.regimen];
        if (treatmentPlans.length > 1) {
          nameArr.push(`${treatmentPlans.length - 1} Other on-pathway treatment`);
        }
        treatmentPlanNodeName = TreatmentNodeHeaders.TREATMENT_PLANS_HEADER + nameArr.join('\n');
      }
      else {
        treatmentPlanNodeName = TreatmentNodeHeaders.TREATMENT_PLANS_HEADER + `${treatmentPlans.length} On-pathway treatment plans`;
      }
      if (clinicalTrial && has(clinicalTrial,'display' )) {
        const ctName = get(clinicalTrial, 'display', '');
        treatmentPlanNodeName = treatmentPlanNodeName.concat('\n').concat(TreatmentNodeHeaders.CLINICAL_TRIALS_HEADER, `${ctName}`);
      }
    }
    return treatmentPlanNodeName;
  }
}
